export default __webpack_public_path__ + "static/media/ami3.ec1e67fa.jpg";